<template>
<div class='error-wrapper'>
  <h1></h1>
  <div class='progress-wrapper'>
    <!-- <el-progress class='convert-progress' type="circle" :percentage="25" :width='200'></el-progress> -->
    <div class='mock-circle'>
      <span class='text'>出错啦</span>
    </div>
    <div class='background-image img'></div>
  </div>

  <p class='hint'>文件内容无法识别，可能已损坏。请重新保存再上传。</p>
  <router-link class='el-button el-button--primary el-button--large' :to="{name: 'project_upload', params: { id: project.id }}">
    重新上传
  </router-link>
</div>
</template>

<script>
export default {
  computed: {
    project() {
      return this.$store.state.project.items[this.$route.params.id]
    }
  }
}
</script>

<style lang='scss' scoped>
$progress-width: 200px;
// change might also need apply to attributes in template
.error-wrapper {
    position: relative;
    h1 {
        margin-top: 60px;
        margin-bottom: $margin-base;
    }

    .progress-wrapper {
        position: relative;
        margin: $margin-base;
        height: $progress-width;

        .mock-circle {
            position: absolute;
            left: 50%;
            margin-left: -80px;
            margin-top: 2em;
            width: 160px;
            height: 160px;
            background-color: $color-white-base;
            overflow: hidden;
            border-radius: 50%;
            box-shadow: $box-shadow-base;

            .text {
                color: $font-color-base;
                z-index: 2;
                position: absolute;
                left: 0;
                text-align: center;
                width: 100%;
                top: 40%;
                font-weight: $font-weight-border;
                font-size: $font-size-large;
            }
        }

        .convert-progress {
            float: left;
            left: 50%;
            margin-left: - 0.5 * $progress-width;
            background-color: $color-white-base;
            border-radius: 50%;
        }

        .background-image {
            width: 640px;
            margin: 0 auto;
            background-image: url('~@/assets/images/project-convert.png');
            background-size: contain;
        }
    }

    .hint {
        margin-top: $margin-base;
        line-height: 1.5;
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?0b8999a0